import { render, staticRenderFns } from "./weekEdit.vue?vue&type=template&id=64829fda&"
import script from "./weekEdit.vue?vue&type=script&lang=js&"
export * from "./weekEdit.vue?vue&type=script&lang=js&"
import style0 from "./weekEdit.vue?vue&type=style&index=0&lang=less&scope=true&"
import style1 from "./weekEdit.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports